var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverShare",on:{"click":function($event){return _vm.shareHide()}}},[_c('img',{attrs:{"src":require("@/assets/images/shareCover.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }